import { BLACK, CRIMSON_500, PALE_YELLOW } from '../../styles/colors';
import { INTER } from '../../styles/fonts';
import styled from 'styled-components';

// Styled components
export const PinContainer = (styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 32px;
  min-height: 24px; /* Ensure consistent height */
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

interface PinDotProps {
  $filled: boolean;
  $error?: boolean;
}

export const PinDot = (styled.div<PinDotProps>`
  width: 16px;
  height: 16px;
  aspect-ratio: 1 / 1;
  border-radius: 100%;
  border-width: 1px;
  border-style: solid;
  border-color: ${(props: PinDotProps) => props.$error ? CRIMSON_500 : props.$filled ? '#000000' : '#D3D3D3'};
  background-color: ${(props: PinDotProps) => {
    if (props.$error) return PALE_YELLOW; // Red color for error state
    return props.$filled ? '#000000' : '#D3D3D3';
  }};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const PinCharacter = (styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${BLACK};
  font-size: 18px;
  font-family: ${INTER.bold};
  aspect-ratio: 1 / 1;
  width: 16px; /* Match dot width */
  height: 16px; /* Match dot height */
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const PinPosition = (styled.div`
  position: relative;
  aspect-ratio: 1 / 1;
  width: 16px; /* Fixed width */
  height: 16px; /* Fixed height */
  display: flex;
  justify-content: center;
  align-items: center;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
